import qs from "qs";

import { axiosWithAuth, timeZoneOffsetInMinutes } from "helpers";

export const autoChecklistService = {
	serpApiCheck,
	getGVerifyGAuthenticateResult,
	reRunGVerifyGAuthenticate,
	getGOFAC,
	reRunGOFAC,
	getMatch,
	getTINCheck,
	reRunTINCheck,
	reRunMatch,
	getInquiryMatchDetails,
	getMerchantMatchDetails,
	getGOFACowner,
	reRunGOFACOwner,
	getGidentifyOwner,
	reRunGidentifyOwner,

	downloadGVerifyGAuthenticationDocument,
	downloadTINCheckDocument,
	downloadGOFACDocument,
	downloadMatchDocument,
	downloadOFACOwnerDocument,
	downloadGidentifyOwnerDocument,
	downloadExperianOwnerDocument,
	downloadAlloyDocument,
	updateMerchantInformation,
	setGofacMerchantAuroraOutcome,
	setGofacOwnerAuroraOutcome,
	setGVerifyGAuthenticationAuroraOutcome,
	setTINCheckAuroraOutcome,
	setMatchAuroraOutcome,
	setGidentifyOwnerAuroraOutcome,

	getExperianDetailed,
	getExperian,
	experianClearFraud,
	setExperianOwnerAuroraOutcome,
	getAlloy,

	updateExperianValues,

	getJarisCheckList,
};

const API_URL = process.env.REACT_APP_API_URL;

//Design does not exist for this method yet
function serpApiCheck(applicationId) {
	const options = {
		method: "GET",
		params: {
			applicationId,
		},
		url: `${API_URL}/api/underwriting/autoCheck/serpApiCheck`,
	};

	return axiosWithAuth(options);
}

function getExperian(applicationId, ownerType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/experian`,
	};

	return axiosWithAuth(options);
}

function getExperianDetailed(applicationId, ownerType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/experian/detailed`,
	};

	return axiosWithAuth(options);
}

function experianClearFraud({ applicationId, ownerType, notes }) {
	const options = {
		method: "POST",
		data: notes,
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/experian/clear_fraud`,
	};

	return axiosWithAuth(options);
}

function setExperianOwnerAuroraOutcome({
	applicationId,
	ownerType,
	auroraOutcome,
}) {
	const options = {
		method: "POST",
		params: { aurora_outcome: auroraOutcome },
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/experian/aurora_outcome`,
	};

	return axiosWithAuth(options);
}

function getGVerifyGAuthenticateResult(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/g_verify_g_authenticate`,
	};

	return axiosWithAuth(options, { returnOriginalResponse: true });
}

function reRunGVerifyGAuthenticate(applicationId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/g_verify_g_authenticate/rerun`,
	};

	return axiosWithAuth(options);
}

function getGOFAC(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/gofac`,
	};

	return axiosWithAuth(options, { returnOriginalResponse: true });
}

function reRunGOFAC(applicationId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/gofac/rerun`,
	};

	return axiosWithAuth(options);
}

function getGOFACowner(applicationId, ownerType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/gofac`,
	};

	return axiosWithAuth(options, { returnOriginalResponse: true });
}

function reRunGOFACOwner(applicationId, ownerType) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/gofac/rerun`,
	};

	return axiosWithAuth(options);
}

function getGidentifyOwner(applicationId, ownerType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/g_identify`,
	};

	return axiosWithAuth(options, { returnOriginalResponse: true });
}

function reRunGidentifyOwner(applicationId, ownerType) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/g_identify/rerun`,
	};

	return axiosWithAuth(options);
}

function getMatch(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/match`,
	};

	return axiosWithAuth(options);
}

function reRunMatch(applicationId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/match/rerun`,
	};

	return axiosWithAuth(options);
}

function getTINCheck(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/tin_check`,
	};

	return axiosWithAuth(options);
}

function reRunTINCheck(applicationId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/tin_check/rerun`,
	};

	return axiosWithAuth(options);
}

function getAlloy(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/alloy`,
	};

	return axiosWithAuth(options, { returnOriginalResponse: true });
}

/**
 * @deprecated No longer available from Mastercard MATCH Pro API
 **/
function getInquiryMatchDetails(applicationId, inquiryMatchIds) {
	const options = {
		method: "GET",
		params: {
			inquried_merchant_ids: inquiryMatchIds,
		},
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/match/inquiry_match_details`,
	};

	return axiosWithAuth(options);
}

function getMerchantMatchDetails(applicationId, merchantMatchIds) {
	const options = {
		method: "GET",
		params: {
			terminated_merchant_ids: merchantMatchIds,
		},
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/match/merchant_match_details`,
	};

	return axiosWithAuth(options);
}

function downloadGVerifyGAuthenticationDocument(applicationId, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/g_verify_g_authenticate/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function downloadTINCheckDocument(applicationId, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/tin_check/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function downloadGOFACDocument(applicationId, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/gofac/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function downloadMatchDocument(applicationId, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/match/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function downloadOFACOwnerDocument(applicationId, ownerType, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/gofac/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function downloadGidentifyOwnerDocument(applicationId, ownerType, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/g_identify/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function downloadExperianOwnerDocument(applicationId, ownerType, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/experian/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function downloadAlloyDocument(applicationId, token) {
	const url = `${API_URL}/api/applications/${applicationId}/underwriting_checks/alloy/download?token=${token}&time_zone_offset_in_minutes=${timeZoneOffsetInMinutes()}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function updateMerchantInformation({
	applicationId,
	chargeback_volume,
	reserve,
	reserve_amount,
	delivery_same_day,
	delivery_from_one_to_three_days,
	delivery_from_four_to_seven_days,
	delivery_from_eight_to_fourteen_days,
	delivery_from_fifteen_to_thirty_days,
	delivery_over_thirty_days,
}) {
	const options = {
		method: "POST",
		data: {
			chargeback_volume,
			reserve,
			reserve_amount,
			delivery_same_day,
			delivery_from_one_to_three_days,
			delivery_from_four_to_seven_days,
			delivery_from_eight_to_fourteen_days,
			delivery_from_fifteen_to_thirty_days,
			delivery_over_thirty_days,
		},
		url: `${API_URL}/api/underwriting/${applicationId}/merchant_information`,
	};

	return axiosWithAuth(options);
}

function setGofacMerchantAuroraOutcome(applicationId, auroraOutcome) {
	const options = {
		method: "POST",
		params: { aurora_outcome: auroraOutcome },
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/gofac/aurora_outcome`,
	};

	return axiosWithAuth(options);
}

function setGofacOwnerAuroraOutcome(applicationId, auroraOutcome, ownerType) {
	const options = {
		method: "POST",
		params: { aurora_outcome: auroraOutcome },
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/gofac/aurora_outcome`,
	};

	return axiosWithAuth(options);
}

function setGidentifyOwnerAuroraOutcome(
	applicationId,
	auroraOutcome,
	ownerType,
) {
	const options = {
		method: "POST",
		params: { aurora_outcome: auroraOutcome },
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/g_identify/aurora_outcome`,
	};

	return axiosWithAuth(options);
}

function setGVerifyGAuthenticationAuroraOutcome(applicationId, auroraOutcome) {
	const options = {
		method: "POST",
		params: { aurora_outcome: auroraOutcome },
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/g_verify_g_authenticate/aurora_outcome`,
	};

	return axiosWithAuth(options);
}

function setTINCheckAuroraOutcome(applicationId, auroraOutcome) {
	const options = {
		method: "POST",
		params: { aurora_outcome: auroraOutcome },
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/tin_check/aurora_outcome`,
	};

	return axiosWithAuth(options);
}

function setMatchAuroraOutcome(applicationId, auroraOutcome) {
	const options = {
		method: "POST",
		params: { aurora_outcome: auroraOutcome },
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/match/aurora_outcome`,
	};

	return axiosWithAuth(options);
}

function updateExperianValues(applicationId, ownerType, model) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/owner/${ownerType}/experian`,
	};

	return axiosWithAuth(options);
}

function getJarisCheckList(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/underwriting_checks/jaris`,
	};

	return axiosWithAuth(options);
}
